
































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import PaginatedList from "@/api/PaginatedList";

class PagerVisibility {
  public visibleLower = 1;
  public visibleHigher = 1;
  public showPrevEllipses = false;
  public showNextEllipses = false;
}

@Component
export default class RenderPager extends Vue {
  @Prop() private paginatedList!: PaginatedList;
  private pagerVisibility = new PagerVisibility();

  mounted() {
    this.getVisible();
  }

  private getTotalPages(): number {
    if (this.paginatedList && this.paginatedList.total && this.paginatedList.perPage) {
      return Math.ceil(this.paginatedList.total / this.paginatedList.perPage);
    }
    return 0;
  }

  private gotoPage(page: number): void {
    const newQuery = Object.create(this.$route.query);
    newQuery.p = page.toString();
    this.$router.push({path: '', query: newQuery})
  }

  private isFirstPage() {
    if (this.paginatedList.page) {
      return this.paginatedList.page == 1;
    }
    return false;
  }

  private isLastPage() {
    if (this.paginatedList.page) {
      return this.paginatedList.page == this.getTotalPages();
    }
    return false;
  }

  private getVisible() {
    const lastPage = this.getTotalPages();
    let currentPage = 1;
    if (this.paginatedList.page) {
      currentPage = this.paginatedList.page;
    }
    let visibleLower = parseInt(currentPage.toString()) - 2;
    let visibleHigher = parseInt(currentPage.toString()) + 2;
    if (visibleLower < 1) {
      visibleLower = 1;
    }
    if (visibleHigher > lastPage) {
      visibleHigher = lastPage;
    }

    this.pagerVisibility.visibleLower = visibleLower;
    this.pagerVisibility.visibleHigher = visibleHigher;
    if (visibleLower > 1) {
      this.pagerVisibility.showPrevEllipses = true;
    } else {
      this.pagerVisibility.showPrevEllipses = false;
    }
    if (visibleHigher < lastPage) {
      this.pagerVisibility.showNextEllipses = true;
    } else {
      this.pagerVisibility.showNextEllipses = false;
    }
  }

  private getVisibleClass(index: number): string {
    if (index > this.pagerVisibility.visibleHigher || index < this.pagerVisibility.visibleLower) {
      return "invisible";
    }
    return "visible";
  }

  get nextPage() {
    if (this.paginatedList.page) {
      return parseInt(this.paginatedList.page.toString()) + 1;
    }
    return 1;
  }

  get prevPage() {
    if (this.paginatedList.page) {
      return parseInt(this.paginatedList.page.toString()) - 1;
    }
    return 1;
  }

  @Watch('paginatedList')
  onRouteChanged() {
    this.getVisible();
  }
}
